import { UNITS } from '../constants/units';

/**
 * Convert temperature between units
 */
function convertTemperature(value, fromUnit, toUnit) {
  if (fromUnit === toUnit) return value;

  // Convert to Celsius first
  let celsius;
  switch (fromUnit) {
    case 'celsius':
      celsius = value;
      break;
    case 'fahrenheit':
      celsius = ((value - 32) * 5) / 9;
      break;
    case 'kelvin':
      celsius = value - 273.15;
      break;
    default:
      return 0;
  }

  // Convert from Celsius to target unit
  switch (toUnit) {
    case 'celsius':
      return celsius;
    case 'fahrenheit':
      return (celsius * 9) / 5 + 32;
    case 'kelvin':
      return celsius + 273.15;
    default:
      return 0;
  }
}

/**
 * Convert units within a category
 */
export function convertUnit(value, fromUnit, toUnit, category) {
  if (fromUnit === toUnit) return value;

  const units = UNITS[category];
  if (!units) return 0;

  // Special handling for temperature
  if (category === 'temperature') {
    return convertTemperature(value, fromUnit, toUnit);
  }

  // For other units, convert through base unit
  const fromUnitData = units[fromUnit];
  const toUnitData = units[toUnit];

  if (!fromUnitData || !toUnitData) return 0;

  const baseValue = value * fromUnitData.toBase;
  return baseValue / toUnitData.toBase;
}

/**
 * Get all unit keys for a category
 */
export function getUnitsForCategory(category, locale) {
  const allUnits = Object.keys(UNITS[category] || {});
  // Only include 'pyeong' for Korean locale; hide it for other locales
  if (category === 'area') {
    return allUnits.filter(u => u !== 'pyeong' || locale === 'ko');
  }
  return allUnits;
}

/**
 * Get unit symbol
 */
export function getUnitSymbol(category, unit) {
  const sym = UNITS[category]?.[unit]?.symbol || '';
  // normalize common superscripts to digits for consistent UI rendering
  return String(sym).replace(/\u00b2/g, '2').replace(/\u00b3/g, '3');
}

/**
 * Format number with appropriate precision
 */
export function formatNumber(num) {
  if (num === 0) return '0';
  if (Math.abs(num) >= 1000000 || Math.abs(num) < 0.0001) {
    return num.toExponential(6);
  }

  // Determine decimal places based on magnitude
  const absNum = Math.abs(num);
  let decimals;
  if (absNum >= 100) decimals = 2;
  else if (absNum >= 1) decimals = 4;
  else if (absNum >= 0.01) decimals = 6;
  else decimals = 8;

  const result = num.toFixed(decimals);
  // Remove trailing zeros
  return parseFloat(result).toString();
}
